import TemplateView from '../../../../js/TemplateView'
import NoFeedsArea from './NoFeedsArea'
import {ICalTabType} from '../constants'
import {connect} from '../../../../js/redux/utils'
import {getActiveTab, isFeedsEmpty} from '../selectors'
import {bindActionCreators} from 'redux'
import {canManageAccountsAndPermissions} from '../../../../js/loggedInUser/selectors'
import FeedsTable from './table/FeedsTable'

class FeedsContent extends TemplateView {

    constructor({
        onCreateButtonClick,
        onExportButtonClick,
    }) {
        super()

        this.state = {
            activeTab: ICalTabType.USER_FEEDS,
            feedsEmpty: false,
            allFeedsAvailable: false,
        }

        this.callbacks = {
            onCreateButtonClick,
            onExportButtonClick,
        }

        this.onStatePropertyChanged('activeTab', activeTab => this.noFeedsArea.setState({mode: activeTab}))

        this.onStatePropertyChanged('feedsEmpty', feedsEmpty => {
            this.feedsTable.toggle(!feedsEmpty)
            this.noFeedsArea.toggle(feedsEmpty)
        })

        this.onStatePropertyChanged('allFeedsAvailable', allFeedsAvailable => this.noFeedsArea.setState({allFeedsAvailable}))
    }

    templateHtml() {
        return `<div class='feedsContent'>
                    <div class='feedsTableWrapper'/>
                    <div class='noFeedsContentWrapper'/>
                </div>`
    }

    afterRender() {
        this.noFeedsArea = new NoFeedsArea({
            onCreateButtonClick: this.callbacks.onCreateButtonClick,
            onExportButtonClick: this.callbacks.onExportButtonClick,
        }).init(this.find('.noFeedsContentWrapper'))

        this.feedsTable = new FeedsTable().init(this.find('.feedsTableWrapper'))
    }
}

export default connect(
    state => ({
        activeTab: getActiveTab(state),
        feedsEmpty: isFeedsEmpty(state),
        allFeedsAvailable: canManageAccountsAndPermissions(state),
    }),
    dispatch => bindActionCreators({}, dispatch)
)(FeedsContent)



// WEBPACK FOOTER //
// ./web/actiplans/js/icalendar/components/FeedsContent.js